import { UberconferenceReconnectButton } from './UberconferenceReconnectButton';
import { UberConferenceServiceComponent } from './UberConferenceServiceComponent';
export const UberconferenceReconnectionConfig = {
  reconnectButton: UberconferenceReconnectButton,
  serviceComponent: UberConferenceServiceComponent
};